import React, { forwardRef } from 'react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

interface PulsatingButtonProps {
  position: {
    top: string;
    left: string;
  };
  size: string;
  onClick: () => void;
}

export const PulsatingButton = forwardRef<HTMLButtonElement, PulsatingButtonProps>(
  ({ position, size, onClick }, ref) => {    

    return (
      <button 
        ref={ref}
        data-testid="pulsating-button"
        onClick={onClick || (() => {})}
        style={{
          position: 'absolute' as const,
          top: position?.top || '0',
          left: position?.left || '0', 
          transform: 'translate(-50%, -50%)',
          width: size,
          height: 'auto',
          aspectRatio: '1 / 1'
        }}
      > 
        <DotLottieReact
          src="./images/pulsating-button/Main Scene (1).lottie"
          loop
          autoplay
          speed={1.5}
          renderConfig={{
            autoResize: true
          }}
        /> 
      </button>
    );
  }
);